import DatePicker from 'rsuite/DatePicker';
import 'rsuite/DatePicker/styles/index.css';
import * as locales from "rsuite/locales";
import {CustomProvider} from "rsuite";
import FormaDePago from "../../../components/catalogo/FormaDePago";
import Cajas from "../../../components/catalogo/Cajas";
import Banco from "../../../components/catalogo/Banco";
import {isAfter} from "date-fns";
import ErrorMessage from "../../../components/helpers/ErrorMessage";
import TiposDeMovimiento from "../../../components/catalogo/TiposDeMovimiento";

/**
 * COMPONENTE DE PAGO
 * @param formik
 * @param mov
 * @returns {JSX.Element}
 * @constructor
 */
export default function PagoCaja({
     formik,
     mov,
 }){

    return(
        <>
            <div className={'col-md-3 mb-7'}>
                <FechaCorte formik={formik}></FechaCorte>
            </div>
            {
                mov && <div className={'col-md-3 mb-7'}>
                    <TiposDeMovimiento formik={formik}></TiposDeMovimiento>
                </div>
            }
            <div className={'col-md-3'}>
                <FormaDePago formik={formik}></FormaDePago>
                <ErrorMessage name={'forma_pago'}></ErrorMessage>
            </div>
            <div className={'col-md-3'}>
                {
                    formik.values.forma_pago === "EF" ? <Cajas formik={formik}></Cajas> : <Banco formik={formik}></Banco>
                }
                <ErrorMessage name={'id_caja'}></ErrorMessage>
            </div>
        </>
    );
}

/**
 *
 * @param formik
 * @returns {JSX.Element}
 * @constructor
 */
export function FechaCorte({formik}) {
    return(
        <>
            <style type={'text/css'}>
                {`
                    .fecha > div{
                        background-color : var(--bs-gray-100)!important;
                        border: 0!important;
                    }
                    
                    #fecha{
                        padding-top: 1.75rem!important;
                        display: block!important;
                        background-color: transparent!important;
                        text-transform: uppercase!important;
                    }
                    
                    .labelSelect {
                        font-size : 1rem;
                        color: rgba(var(--bs-body-color-rgb),.65);
                        transform: scale(.85) translateY(-.5rem) translateX(.15rem);
                        position : absolute;
                        left : 0;
                    }
                    
                    .rs-input-group.rs-input-group-disabled .rs-input, .rs-input-group.rs-input-group-disabled .rs-input-group-btn, .rs-input-group.rs-input-group-disabled .rs-input-group-addon{
                        color:var(--bs-text-gray-700)!important;
                    }
                `}
            </style>
            <CustomProvider locale={locales.esES}>
                <DatePicker
                    oneTap
                    className={'fecha'}
                    label={<div className={'labelSelect ps-4 pb-4'}>Fecha:</div>}
                    id={'fecha'}
                    name={'fecha'}
                    style={{ width: "100%" }}
                    cleanable={false}
                    format={'MMM dd, yyyy'}
                    value={formik.values.fecha}
                    onChange={value => formik.setFieldValue('fecha', value)}
                    shouldDisableDate={(date) => isAfter(date, new Date())}
                />
            </CustomProvider>
        </>
    );
}
